import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Output } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
declare const Webcam: any;

@Component({
  selector: 'app-web-cam',
  templateUrl: './web-cam.component.html',
  styleUrls: ['./web-cam.component.scss']
})
export class WebCamComponent implements OnInit, AfterViewInit {

  protected config = {
    width: 370,
    height: 230,
    dest_width: 1280,
    dest_height: 720,
    image_format: 'jpeg',
    jpeg_quality: 90
  };

  @ViewChild('canvas') canvas: ElementRef;
  @Output() emitterAction: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    Webcam.set(this.config);
    Webcam.attach( this.canvas.nativeElement );
  }

  /**
   * @description Carturar foto
   * @method capturePhoto
   */
  capture () {
    const self = this;
    Webcam.snap(function (data) {
      self.emitterAction.emit({
        config: self.config,
        data: data
      });
    });
  };

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/web-cam/web-cam.component.ts